import {cashBoxViewPage} from "../../../hoc/cashBoxViewPage";

const Expense = cashBoxViewPage("Expense")
export default Expense
